export type CameraIconProps = {
  className?: string;
};

export default ({ className }: CameraIconProps) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" className={className}>
    <path
      d="M28.75,13.5c-2.55,0-4.62,2.07-4.62,4.62v0.17h-9.76c-2.55,0-4.62,2.07-4.62,4.62v22.95
      c0,2.55,2.07,4.62,4.62,4.62h35.29c2.55,0,4.62-2.07,4.62-4.62V22.92c0-2.55-2.07-4.63-4.62-4.63h-9.08v-0.17
      c0-2.55-2.07-4.62-4.62-4.62H28.75z M43.99,34.4c0,6.62-5.37,11.99-11.99,11.99S20.01,41.02,20.01,34.4S25.38,22.41,32,22.41
      S43.99,27.78,43.99,34.4z M32,42.96c4.73,0,8.56-3.83,8.56-8.56c0-4.73-3.83-8.56-8.56-8.56s-8.56,3.83-8.56,8.56
      C23.44,39.13,27.27,42.96,32,42.96z"
    />
  </svg>
);
